import { ref, type Ref } from "vue";
import { BaseService, ErrorResponse } from "../base";
import type { Features } from "./model";

export const FeaturesServiceSymbol = Symbol();

export interface IFeatureService {
  Features: Ref<Features>;

  LoadActiveFeatures(): Promise<void>;
  IsFeatureActive(name: string): boolean;
  IsLocalhost(): boolean;
}

export class FeatureService extends BaseService implements IFeatureService {
  private _features: Ref<Features>;
  private _ENABLED_DEVFEATURES: Ref<Features>;

  get Features(): Ref<Features> {
    return this._features;
  }

  constructor(baseUri: string, token: string) {
    super(baseUri, token);
    this._features = ref<Features>({ activeFeatures: [] });
    this._ENABLED_DEVFEATURES = ref<Features>({ 
      activeFeatures: [] 
    });
  }

  async LoadActiveFeatures(): Promise<void> {
    // TODO: DEV, not needed for current stage.
    return;
    // let result: Features | ErrorResponse = await this.Get<Features>('', true);

    // if (result instanceof ErrorResponse) {
    //   console.log(result.message);
    //   return;
    // }

    // this._features.value = result;
  }

  IsFeatureActive(name: string): boolean {
    return this._ENABLED_DEVFEATURES.value.activeFeatures?.some((f: string) => f === name); // TODO: DEV
      //return this._features.value.activeFeatures?.some((f: string) => f === name) /*|| this.IsLocalhost()*/;
  }

  IsLocalhost(): boolean {
    return window.location.toString().includes("localhost") || window.location.toString().includes("127.0.0.1");
  }
}